import {
  COMUNICATION_SIDEBAR_SHOW_OFF,
  ALERT_SET,
  ALERT_DELETE,
  ALERT_SET_LOADING_STATUS,
  ALERT_CLEAR,
  ALERT_SET_COUNT,
  ALERT_SET_FOR_LABORATORY,
  ALERT_SET_AS_READ,
  ALERT_CLEAR_FOR_LABORATORY,
  TAB_SHOW_OFF,
  MESSAGE_DELETE,
  MESSAGE_SET_FOR_LABORATORY,
  MESSAGE_CLEAR,
  MESSAGE_SET_AS_READ,
  MESSAGE_SET_COUNT
} from '../types'
import comunicationService from '@/api/comunication'
import { getCookie } from '../../utils/auth-utils'
import Moment from 'moment'

const state = {
  comunicationSidebarShowOff: false,
  notifications: [],
  alertLoadingStatus: 'STATUS_INITIAL',
  alertsCount: 0,
  notificationsForLaboratories: [],
  tabShowOff: false,
  messageForLaboratories: [],
  messageCount: 0,
  readedNotifications: []
}

const mutations = {
  // Sidebar
  [COMUNICATION_SIDEBAR_SHOW_OFF](state, value) {
    state.comunicationSidebarShowOff = value
  },
  // Tabs
  [TAB_SHOW_OFF](state, value) {
    state.tabShowOff = value
  },
  // Notificações
  [ALERT_SET](state, notifications) {
    state.notifications = notifications
  },
  [ALERT_DELETE](state, index) {
    state.notifications.splice(index, 1)
    state.alertsCount--
  },
  [ALERT_SET_LOADING_STATUS](state, alertLoadingStatus) {
    state.alertLoadingStatus = alertLoadingStatus
  },
  [ALERT_CLEAR](state) {
    state.notifications = []
  },
  [ALERT_SET_COUNT](state, value) {
    state.alertsCount = value
  },
  [ALERT_SET_FOR_LABORATORY](state, notificationsForLaboratories) {
    state.notificationsForLaboratories = notificationsForLaboratories
  },
  [ALERT_SET_AS_READ](state, notification) {
    state.notifications = notification
  },
  [ALERT_CLEAR_FOR_LABORATORY](state) {
    state.notificationsForLaboratories = []
  },
  // Mensagens
  [MESSAGE_DELETE](state, index) {
    state.messageForLaboratories.splice(index, 1)
    state.messageCount--
  },
  [MESSAGE_SET_FOR_LABORATORY](state, messageForLaboratories) {
    state.messageForLaboratories = messageForLaboratories
  },
  [MESSAGE_CLEAR](state) {
    state.messageForLaboratories = []
  },
  [MESSAGE_SET_AS_READ](state, message) {
    state.messageForLaboratories = message
  },
  [MESSAGE_SET_COUNT](state, value) {
    state.messageCount = value
  },
  setReadedNotifications(state, readedNotifications) {
    state.readedNotifications = readedNotifications
  }
}

const getters = {
  // Sidebar
  isComunicationSidebarVisible: state => {
    return state.comunicationSidebarShowOff
  },
  // Tab
  whereIsTabSelected: state => {
    return state.tabShowOff
  },
  // Notificações
  notifications: state => {
    return state.notifications
  },
  alertLoadingStatus: state => {
    return state.alertLoadingStatus
  },
  getAlertsNumber: state => {
    return state.alertsCount
  },
  notificationsForLaboratories: state => {
    return state.notificationsForLaboratories
  },
  readedNotifications: state => {
    return state.readedNotifications
  },
  // Mensagens
  getMessagesNumber: state => {
    return state.messageCount
  },
  messageForLaboratories: state => {
    return state.messageForLaboratories
  }
}

const actions = {
  setComunicationSidebarShowOff: function ({ commit }, value) {
    commit(COMUNICATION_SIDEBAR_SHOW_OFF, value)
  },
  changeTabShowOff: function ({ commit }, value) {
    commit(TAB_SHOW_OFF, value)
  },
  getServiceAlert: function ({ commit, dispatch, state }) {
    return comunicationService
      .getAllAlerts()
      .then(response => {
        let notifications = response.data
        if (notifications && notifications.length > 0) {
          commit(ALERT_SET, notifications)
          commit(ALERT_SET_LOADING_STATUS, 'STATUS_END')
        } else {
          commit(ALERT_SET_LOADING_STATUS, 'STATUS_END')
        }
      })
      .catch(() => {
        commit(ALERT_SET_LOADING_STATUS, 'STATUS_FAILED')
      })
  },
  setInitialLoadingStatus: function ({ commit }) {
    commit(ALERT_SET_LOADING_STATUS, 'STATUS_INITIAL')
  },
  clearAllAlertData: function ({ commit }) {
    commit(ALERT_SET_LOADING_STATUS, 'STATUS_INITIAL')
    commit(ALERT_CLEAR)
  },
  clearAlertDataForLaboratory: function ({ commit }) {
    commit(ALERT_CLEAR_FOR_LABORATORY)
  },
  getAlertsForLaboratory({ commit }) {
    let profile = getCookie('profile')
    let startDate = Moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00'
    let endDate = Moment(new Date()).format('YYYY-MM-DD') + ' 23:59:59'

    return comunicationService
      .getAlertsForLaboratory({
        idLaboratory: profile.id_laboratory,
        startDate: startDate,
        endDate: endDate,
        enabled: 1
      })
      .then(response => {
        let size = response.data.notification.length
        let notificationsForLaboratories = response.data.notification
        let readedNotifications = response.data.notificationHistory.sort((a, b) => new Date(b['read-date']) - new Date(a['read-date']));

        commit(ALERT_SET_FOR_LABORATORY, notificationsForLaboratories)
        commit('setReadedNotifications', readedNotifications)
        commit(ALERT_SET_COUNT, size)
      })
  },
  clearAllMessageData: function ({ commit }) {
    commit(MESSAGE_CLEAR)
  },
  deleteSelectedMessages({ commit }, index) {
    commit(MESSAGE_DELETE, index)
  },
  deleteSelectedAlerts({ commit }, index) {
    commit(ALERT_DELETE, index)
  },
  getMessagesForLaboratory({ commit }) {
    let profile = getCookie('profile')
    let startDate = Moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
    let endDate = Moment(new Date()).format('YYYY-MM-DD hh:mm:ss')

    return comunicationService
      .getMessagesForLaboratory({
        idLaboratory: profile.id_laboratory,
        startDate: startDate,
        endDate: endDate,
        enabled: 1
      })
      .then(response => {
        let size = response.data.length
        let messagesForLaboratories = response.data
        commit(MESSAGE_SET_FOR_LABORATORY, messagesForLaboratories)
        commit(MESSAGE_SET_COUNT, size)
      })
      .catch(response => {
        console.log(response)
      })
  }
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
